import { cx } from "@emotion/css";
import ScrollLayout from "library/Layouts/ScrollLayout";
import { PropTypes } from "prop-types";
import styles from "./OrderListLayout.styles";

const OrderListLayout = ({ filtersSection, skeletonSection, listSection, emptyListSection, paginationSection }) => (
  <div
    className={cx(
      styles.container,
      "flex-1 position-relative d-flex flex-column justify-content-between px-0 overflow-hidden"
    )}
  >
    {filtersSection}

    <ScrollLayout className="d-flex flex-1 flex-column">{skeletonSection || listSection}</ScrollLayout>

    {emptyListSection}

    {paginationSection}
  </div>
);

OrderListLayout.defaultProps = {
  filtersSection: null,
  skeletonSection: null,
  listSection: null,
  emptyListSection: null,
  paginationSection: null,
};

OrderListLayout.propTypes = {
  filtersSection: PropTypes.node,
  skeletonSection: PropTypes.node,
  listSection: PropTypes.node,
  emptyListSection: PropTypes.node,
  paginationSection: PropTypes.node,
};

export default OrderListLayout;
